import store from "@/store";
import {parseJwt} from "@/controllers/ParseToken";
import {userRoleService} from "@/services/userRoleService";

export default {

  formatDate(val, separator = '.', year = '2-digit', month = '2-digit', day = '2-digit', opts) {
    let defaults = {
      format: '' //commaBeforeYear, yearFirst
    }

    let res;
    let options = Object.assign(defaults, opts)

    let d = new Date(val);
    let ye = new Intl.DateTimeFormat('en-US', { year: year }).format(d);
    let mo = new Intl.DateTimeFormat('en-US', { month: month }).format(d);
    if(mo.length === 1) {
      mo = 0 + mo
    }
    let da = new Intl.DateTimeFormat('en-US', { day: day }).format(d);

    res = `${da}${separator}${mo}${separator}${ye.slice(-2)}`;

    if(options.format === 'commaBeforeYear') {
      res = `${mo}${separator}${da}, ${ye}`;
    }
    if(options.format === 'yearFirst') {
      res = `${ye}${separator}${mo}${separator}${da}`;
    }

    return res
  },

  formatTime(val, separator = ':', hour = '2-digit', minute = 'numeric') {
    let d = new Date(val);
    let HH = new Intl.DateTimeFormat('en-US', { hour: hour, hour12: false }).format(d);
    let mm = new Intl.DateTimeFormat('en-US', { minute: minute }).format(d);
    if(mm.length === 1) {
      mm = mm + 0
    }
    return `${HH}${separator}${mm}`
  },

  formatDateTimeString(date, time, edit = false, add = false) {
    let d = new Date();
    let tz = d.toString().split("GMT")[1].split(" (")[0].splice(3, 0, ":")
    let res = '';

    if(!add) {
      res = this.formatDate(date, '-', 'numeric', '2-digit', '2-digit', {
        format: 'yearFirst'
      }) + ' ' + time + ':00' + tz
    }
    else {
      res = this.formatDate(date, '-', 'numeric', '2-digit', '2-digit', {
        format: 'yearFirst'
      }) + 'T' + time + ':00' + tz
    }

    return {
      res: res,
      tz: tz
    }
  },

  getDateTimeDistance(dateTimeStringStart, dateTimeStringEnd) {
    let startDateMilliseconds = new Date(dateTimeStringStart).getTime()
    let endDateMilliseconds = new Date(dateTimeStringEnd).getTime()

    return endDateMilliseconds - startDateMilliseconds
  },

  getDaysLeft(milliseconds) {
    let h = milliseconds / 1000 / 60 / 60;
    let h_left = Math.floor(h % 24);
    let days = Math.floor(h/24)

    return {
      h: h_left,
      days: days
    }
  },

  popupController({ popupActive = false, popupState = '' } = {}) {
    this.popupActive = popupActive
    this.popupState = popupState
  },

  getImagePath(path) {
    if(path.indexOf('https://') !== -1 || path.indexOf('http://') !== -1) {
      return path
    }
    else {
      return store.state.baseImgPath + path
    }
  },

  async getUserRoleNew(value = [], status) {
    value.filter(elem => elem.name === Boolean(status))
  },

  async getUserRole (_token) {
    let token = parseJwt(_token.accessToken)
    let userId = token.id
    let userRole = await userRoleService.getUserRoles(token.id)

    if(userRole.length === 0) {
      return 'visitor';
    }
    else {
      //console.log('this.userRole', userRole[0].role)
      let roleName = await this.getRole(userRole[0].role)
      return roleName
    }
  },

  async getRole(id) {
    return await userRoleService.getRole(id)
  }
}
